
export interface FilterApiItemInterface {
    id: string,
    value: string | number,
    index?: number,
}

export function generateFilter(params: FilterApiItemInterface | FilterApiItemInterface[]): string {
    if (Array.isArray(params)) {
        return params.reduce((filterString: string, current: FilterApiItemInterface, index: number) => {
            const useIndex = current.index ?? index;
            return filterString + `filters[${useIndex}][id]=${current.id}&filters[${useIndex}][value]=${current.value}&`;
        }, '');
    }

    if (params.id) {
        const index = params.index ?? 0
        return `filters[${index}][id]=${params.id}&filters[${index}][value]=${params.value}&`;
    }

    return '';
}